import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.service-analysis')
  .factory('ServiceAnalysisApi', ServiceAnalysisApi);

function ServiceAnalysisApi(): BringozApi {
  return {
    base: `/servicesAnalysisGenerateTask`,
    infiniteScroll: {
      address: `/servicesAnalysisGenerateTask`,
      cmd: 'GET'
    },
    actions: {
      getGeneratingRoutes: {
        address: '',
        cmd: 'GET',
        updateable: false
      },
      getGeneratingProcess: {
        address: '{id}',
        cmd: 'GET',
        updateable: false
      },
      cancelGeneratingRoutes: {
        address: '',
        cmd: 'DELETE',
        updateable: false
      },
      cancelGeneratingRouteById: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: false
      }
    }
  }
}
